module.exports = __webpack_public_path__ + "media/images/sample-pdf-doc-974c641993e17d3911b451f4cab4722c.png";